import React, { PropsWithChildren } from 'react'
import { useCardAccordion } from '../Hooks/CardAccordion';
import { Language } from '../language';
import { insertPublicUrl, WorkshopMenuItem } from '../Models/workshopMenu';

import './MenuItemPage.scss'

export interface MenuItemPageProps  {
	language: Language
	menuItem: WorkshopMenuItem
}

export function MenuItemPage(props: PropsWithChildren<MenuItemPageProps>) {
	useCardAccordion()

	let __html = ''
	if (props.menuItem.pageContent?.[props.language]) {
		__html = insertPublicUrl(props.menuItem.pageContent[props.language])
	}

	let className = props.menuItem.page?.replaceAll('/', '') + '-page p-1'

	return (
		<>
			<div className={className} dangerouslySetInnerHTML={{ __html }} />
			<div>
				{props.children}
			</div>
		</>
	)
}

export default MenuItemPageProps